import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingEntrepreneur.css";

export default function EntrepreneurLandingPage() {
  const screenshots = [
    "/screen1.png",
    "/screen2.png",
    "/screen3.png",
    "/screen4.png",
    "/screen5.png",
  ];

  const [currentScreen, setCurrentScreen] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreen((prev) => (prev + 1) % screenshots.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  const goToRegister = () => {
    navigate("/register");
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });

    setMenuOpen(false);
  };

  return (
    <div className="landing entrepreneur-landing">

      {/* =====================================================
          NAVBAR
      ====================================================== */}
      <nav className={`navbar ${menuOpen ? "menu-is-open" : ""}`}>

        <div
          className="logo"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <img
            src="/logo-side-by-side.png"
            alt="Nessefy Logo"
            className="logo-img"
          />
        </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>

          <a href="#why" onClick={() => setMenuOpen(false)}>
            Why Nessefy
          </a>

          <a href="#how" onClick={() => setMenuOpen(false)}>
            How It Works
          </a>

          <a href="#community" onClick={() => setMenuOpen(false)}>
            Community
          </a>

        </div>

        <div className="nav-actions">

          <button
            className="nav-login"
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>

          <button
            className="nav-btn"
            onClick={goToRegister}
          >
            Join Free
          </button>

          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>
      </nav>


      {/* =====================================================
          HERO
      ====================================================== */}
      <section className="hero entrepreneur-hero">

        <div className="hero-blob blob-1"></div>
        <div className="hero-blob blob-2"></div>
        <div className="hero-blob blob-3"></div>

        <div className="hero-content">

          <p className="hero-badge">
            🚀 BUILT FOR PEOPLE WHO BUILD BUSINESSES
          </p>

          <h1>
            Your Business
            <br />
            Can Go Further.
            <br />

            <span className="highlight">
              Find The People
              <span> Who Can Help.</span>
            </span>
          </h1>

          <p>
            Connect with entrepreneurs, founders, investors, freelancers,
            mentors and business minds who can help you turn your ideas
            into opportunities and your opportunities into growth.
          </p>

          <div className="hero-buttons">

            <button
              className="primary-btn"
              onClick={goToRegister}
            >
              🚀 Grow With Nessefy
              <span className="button-arrow">→</span>
            </button>

            <button
              className="secondary-btn"
              onClick={() => scrollTo("how")}
            >
              See How It Works
            </button>

          </div>

          <div className="free-points">

            <span>
              <b>✓</b> 100% free to join
            </span>

            <span>
              <b>✓</b> No credit card
            </span>

            <span>
              <b>✓</b> Built for entrepreneurs
            </span>

          </div>

        </div>


        {/* =====================================================
            HERO VISUAL
        ====================================================== */}
        <div className="hero-card entrepreneur-hero-card">

          <div className="floating-mini-card mini-card-1">

            <h4>
              🚀 Business Growth
            </h4>

            <p>
              Meet people who can move your business forward.
            </p>

          </div>

          <div className="post-card entrepreneur-post-card">

            <div className="entrepreneur-network">

              <div className="network-circle network-one">
                👨🏻‍💼
              </div>

              <div className="network-circle network-two">
                👩🏻‍💼
              </div>

              <div className="network-circle network-three">
                👨🏽‍💻
              </div>

              <div className="network-line line-one"></div>
              <div className="network-line line-two"></div>
              <div className="network-line line-three"></div>

              <div className="network-center">

                <img
                  src="/n-logo.png"
                  alt="Nessefy"
                />

              </div>

            </div>


            <div className="post-card-copy">

              <h3>
                Build. Connect. Grow.
              </h3>

              <p>
                The right people can turn a business idea into
                something much bigger.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FREE STRIP
      ====================================================== */}
      <section className="free-strip">

        <div className="free-strip-icon">
          ✓
        </div>

        <div>

          <strong>
            Joining Nessefy is completely free.
          </strong>

          <span>
            Create your profile, discover opportunities and connect
            with people who can help your business grow.
          </span>

        </div>

        <button onClick={goToRegister}>
          Join Free →
        </button>

      </section>


      {/* =====================================================
          SHOWCASE
      ====================================================== */}
      <section className="showcase">

        <div className="showcase-content">

          <span className="showcase-tag">
            GROW YOUR BUSINESS NETWORK
          </span>

          <h2>

            Stop building
            <br />
            alone.
            <br />

            <span className="showcase-highlight">
              Build with the right people.
            </span>

          </h2>

          <p>
            Nessefy brings the business ecosystem into one place.
            Discover entrepreneurs, founders, investors, freelancers,
            mentors and professionals who can open doors, share expertise
            and create opportunities with you.
          </p>

           <div className="app-download-buttons">

  <a
    href="https://play.google.com/store/apps/details?id=com.niteshagarwal8290.nessefymobile"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./Google-Play-Icon.png"
      alt="Get it on Google Play"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>GET IT ON</small>
      <strong>Google Play</strong>
    </span>
  </a>


  <a
    href="YOUR_APP_STORE_LINK"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./App-Store.png"
      alt="Download on the App Store"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>DOWNLOAD ON THE</small>
      <strong>App Store</strong>
    </span>
  </a>

</div>

          <div className="showcase-benefits">

            <div>

              <span>
                01
              </span>

              <strong>
                Discover
              </strong>

              <p>
                Find people, businesses and opportunities relevant
                to your journey.
              </p>

            </div>


            <div>

              <span>
                02
              </span>

              <strong>
                Connect
              </strong>

              <p>
                Build meaningful professional relationships beyond
                traditional networking.
              </p>

            </div>


            <div>

              <span>
                03
              </span>

              <strong>
                Grow
              </strong>

              <p>
                Turn conversations and connections into real
                business opportunities.
              </p>

            </div>

          </div>

        </div>


        {/* PHONE */}

        <div className="phone-showcase">

          <div className="floating-ui ui-top-left">
            🚀 Business Opportunities
          </div>

          <div className="floating-ui ui-top-right">
            🤝 Meaningful Connections
          </div>

          <div className="floating-ui ui-bottom-left">
            💡 Business Insights
          </div>

          <div className="floating-ui ui-bottom-right">
            ✨ Free to Join
          </div>


          <div className="phone-frame">

            <div className="phone-notch"></div>

            <div className="phone-screen">

              <img
                key={currentScreen}
                src={screenshots[currentScreen]}
                alt="Nessefy App"
                className="phone-screenshot"
              />

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          WHY SECTION
      ====================================================== */}
      <section
        id="why"
        className="features"
      >

        <div className="features-header">

          <span className="features-tag">
            WHY ENTREPRENEURS JOIN NESSEFY
          </span>

          <h2>
            Your network
            <br />
            can change your business.
          </h2>

          <p>
            Entrepreneurship isn't just about having a great idea.
            It's about having access to the right people, knowledge,
            opportunities and resources when you need them.
          </p>

        </div>


        <div className="journey-container">

          <div className="journey-card">

            <div className="journey-step">
              01
            </div>

            <div className="journey-icon">
              🔎
            </div>

            <h3>
              Discover
            </h3>

            <p>
              Discover entrepreneurs, experts, businesses and
              opportunities that align with your goals.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card featured-journey">

            <div className="journey-step">
              02
            </div>

            <div className="journey-icon">
              🤝
            </div>

            <h3>
              Connect
            </h3>

            <p>
              Build relationships with people who bring new
              skills, ideas, resources and perspectives.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card">

            <div className="journey-step">
              03
            </div>

            <div className="journey-icon">
              📈
            </div>

            <h3>
              Grow
            </h3>

            <p>
              Turn the right relationships into partnerships,
              customers, investments and growth.
            </p>

          </div>

        </div>


        <div className="features-stats">

          <div>

            <h4>
              FREE
            </h4>

            <p>
              Join Nessefy
            </p>

          </div>


          <div>

            <h4>
              AI
            </h4>

            <p>
              Smarter discovery
            </p>

          </div>


          <div>

            <h4>
              1
            </h4>

            <p>
              Business ecosystem
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          HOW IT WORKS
      ====================================================== */}
      <section
        id="how"
        className="about"
      >

        <div className="about-content">

          <span className="about-tag">
            HOW IT WORKS
          </span>

          <h2>

            From
            <br />

            “I want to grow”
            <br />

            to

            <span className="how-highlight">
              “Let's build.”
            </span>

          </h2>

          <p>
            You don't need to know everyone in the business world.
            Start with your profile, tell people about your business
            and goals, and discover the people and opportunities that
            can help you move forward.
          </p>


          <div className="about-points">

            <div>

              <h4>
                01 — Create your profile
              </h4>

              <p>
                Tell the community who you are, what you do,
                what you're building and what you're looking for.
              </p>

            </div>


            <div>

              <h4>
                02 — Discover your ecosystem
              </h4>

              <p>
                Explore entrepreneurs, investors, freelancers,
                founders and professionals relevant to your journey.
              </p>

            </div>


            <div>

              <h4>
                03 — Create opportunities
              </h4>

              <p>
                Start conversations, collaborate and turn
                meaningful connections into real opportunities.
              </p>

            </div>

          </div>

        </div>


        {/* ORBIT */}

        <div className="about-visual">

          <div className="orbit-card about-card-1">
            Entrepreneur
          </div>

          <div className="orbit-card about-card-2">
            Investor
          </div>

          <div className="orbit-card about-card-3">
            Freelancer
          </div>

          <div className="orbit-card about-card-4">
            Founder
          </div>

          <div className="orbit-card about-card-5">
            Customer
          </div>


          <div className="about-center-card entrepreneur-center-card">

            <img
              src="/n-logo.png"
              alt="Nessefy Logo"
            />

            <h3>
              Grow Together
            </h3>

            <p>
              People • Ideas • Opportunities
            </p>

          </div>

        </div>

      </section>


      {/* =====================================================
          COMMUNITY
      ====================================================== */}
      <section
        id="community"
        className="community-section"
      >

        <div className="community-content">

          <span className="community-tag">
            ONE BUSINESS ECOSYSTEM
          </span>

          <h2>
            The next opportunity
            <br />
            could be one connection away.
          </h2>

          <p>
            Nessefy brings together entrepreneurs, founders,
            investors, freelancers, professionals and business
            thinkers who want to connect, collaborate and grow.
          </p>


          <div className="community-people">

            <div className="community-avatar">
              👨🏻‍💼
            </div>

            <div className="community-avatar">
              👩🏻‍💻
            </div>

            <div className="community-avatar">
              👨🏽‍💼
            </div>

            <div className="community-avatar">
              👩🏽‍🚀
            </div>

            <div className="community-avatar">
              👨🏻‍🎨
            </div>

            <div className="community-count">
              +
            </div>

          </div>


          <div className="community-labels">

            <span>
              Entrepreneurs
            </span>

            <span>
              Founders
            </span>

            <span>
              Investors
            </span>

            <span>
              Freelancers
            </span>

            <span>
              Professionals
            </span>

          </div>

        </div>

      </section>


      {/* =====================================================
          FINAL CTA
      ====================================================== */}
      <section className="contact-section final-entrepreneur-cta">

        <div className="contact-content">

          <span className="contact-tag">
            YOUR NEXT OPPORTUNITY
          </span>

          <h2>
            Don't build your
            <br />
            business
            <br />
            alone.
          </h2>

          <h3>
            Build your network
            <span> on Nessefy.</span>
          </h3>

          <p>
            Join for free. Create your profile.
            Discover people, ideas and opportunities
            that can help you take your business further.
          </p>


          <button
            className="primary-btn final-cta-button"
            onClick={goToRegister}
          >
            🚀 Join Nessefy
            <span>— It's Free</span>
          </button>


          <div className="final-free-line">

            ✓ Free to join

            <span>
              •
            </span>

            ✓ No credit card

            <span>
              •
            </span>

            ✓ Takes less than 2 minutes

          </div>

        </div>


        {/* FREE CARD */}

        <div className="contact-card final-free-card">

          <div className="free-card-icon">
            ✓
          </div>

          <span>
            NO CATCH.
          </span>

          <h3>
            Nessefy is
            <br />

            <strong>
              100% FREE
            </strong>

            <br />

            to join.
          </h3>

          <p>
            Create your profile and start
            connecting with people who can
            help your business grow.
          </p>

          <button
            onClick={goToRegister}
            className="free-card-button"
          >
            Create My Free Profile →
          </button>

        </div>

      </section>


      {/* =====================================================
          FOOTER
      ====================================================== */}
      <footer className="footer">

        <p>
          © 2026 Nessefy. All rights reserved.
        </p>

        <div className="footer-links">

          <span
            onClick={() =>
              navigate("/privacy-policy")
            }
          >
            Privacy Policy
          </span>

          <span
            onClick={() =>
              navigate("/terms-and-conditions")
            }
          >
            Terms & Conditions
          </span>

        </div>

      </footer>

    </div>
  );
}